import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { FreshdeskConnector } from '../../connector';

export const FreshdeskService = IntegrationService.make({
  connector: FreshdeskConnector,
  name: Integration_Service_Names_Enum.Freshdesk,
});
